module.exports = __webpack_public_path__ + "img/79.e18d6096.jpg";